module.exports = require("serialize-error");


//////////////////
// WEBPACK FOOTER
// external "serialize-error"
// module id = 117
// module chunks = 0